import React from 'react';

export const DeleteCheck = ({ color = '#242424' }: { color: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" fill={color} />
    <path d="M6 12L18 12" stroke="white" strokeWidth="2" />
  </svg>
);
